"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CDN_URL = exports.BASE_URL = void 0;
var BASE_URL = "https://www.nerdwallet.com";
exports.BASE_URL = BASE_URL;
var CDN_URL = "".concat(BASE_URL, "/cdn");
exports.CDN_URL = CDN_URL;
